import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarburstIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "-10 -10 20 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			id: "ray",
			d: "M3 -1h5.5v2h-5.5z",
			fill: "currentColor"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(0)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(45)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(90)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(135)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(180)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(225)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(270)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "rotate(315)",
			children: /* @__PURE__ */ _jsx("use", { href: "#ray" })
		})
	]
});
export default SvgStarburstIcon;
